"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.showToast = exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactToastify = require("react-toastify");

var _styles = require("./styles");

require("react-toastify/dist/ReactToastify.css");

var CheckCircleIcon = function CheckCircleIcon(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("path", {
    d: "M8 0C3.58065 0 0 3.6129 0 8C0 12.4194 3.58065 16 8 16C12.3871 16 16 12.4194 16 8C16 3.6129 12.3871 0 8 0ZM8 1.54839C11.5484 1.54839 14.4516 4.45161 14.4516 8C14.4516 11.5806 11.5484 14.4516 8 14.4516C4.41935 14.4516 1.54839 11.5806 1.54839 8C1.54839 4.45161 4.41935 1.54839 8 1.54839ZM12.5161 5.77419L11.7742 5.03226C11.6452 4.87097 11.3871 4.87097 11.2258 5.03226L6.67742 9.54839L4.74194 7.6129C4.58065 7.45161 4.35484 7.45161 4.19355 7.6129L3.45161 8.32258C3.32258 8.48387 3.32258 8.74194 3.45161 8.87097L6.3871 11.8387C6.54839 12 6.77419 12 6.93548 11.8387L12.5161 6.32258C12.6452 6.16129 12.6452 5.90323 12.5161 5.77419Z"
  }));
};

CheckCircleIcon.defaultProps = {
  viewBox: "0 0 16 16",
  fill: "#ffffff",
  xmlns: "http://www.w3.org/2000/svg"
};

var InfoIcon = function InfoIcon(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("path", {
    d: "M6 0C2.68548 0 0 2.70968 0 6C0 9.31452 2.68548 12 6 12C9.29032 12 12 9.31452 12 6C12 2.70968 9.29032 0 6 0ZM6 10.8387C3.31452 10.8387 1.16129 8.68548 1.16129 6C1.16129 3.33871 3.31452 1.16129 6 1.16129C8.66129 1.16129 10.8387 3.33871 10.8387 6C10.8387 8.68548 8.66129 10.8387 6 10.8387ZM6 2.66129C5.41935 2.66129 4.98387 3.12097 4.98387 3.67742C4.98387 4.25806 5.41935 4.69355 6 4.69355C6.55645 4.69355 7.01613 4.25806 7.01613 3.67742C7.01613 3.12097 6.55645 2.66129 6 2.66129ZM7.35484 8.80645V8.22581C7.35484 8.08065 7.20968 7.93548 7.06452 7.93548H6.77419V5.51613C6.77419 5.37097 6.62903 5.22581 6.48387 5.22581H4.93548C4.76613 5.22581 4.64516 5.37097 4.64516 5.51613V6.09677C4.64516 6.26613 4.76613 6.3871 4.93548 6.3871H5.22581V7.93548H4.93548C4.76613 7.93548 4.64516 8.08065 4.64516 8.22581V8.80645C4.64516 8.97581 4.76613 9.09677 4.93548 9.09677H7.06452C7.20968 9.09677 7.35484 8.97581 7.35484 8.80645Z"
  }));
};

InfoIcon.defaultProps = {
  viewBox: "0 0 12 12",
  fill: "#637792",
  xmlns: "http://www.w3.org/2000/svg"
};

var TimesCircleIcon = function TimesCircleIcon(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("path", {
    d: "M8 0C3.58065 0 0 3.58065 0 8C0 12.4194 3.58065 16 8 16C12.4194 16 16 12.4194 16 8C16 3.58065 12.4194 0 8 0ZM8 14.4516C4.41935 14.4516 1.54839 11.5806 1.54839 8C1.54839 4.45161 4.41935 1.54839 8 1.54839C11.5484 1.54839 14.4516 4.45161 14.4516 8C14.4516 11.5806 11.5484 14.4516 8 14.4516ZM11.2581 6C11.4194 5.87097 11.4194 5.6129 11.2581 5.45161L10.5484 4.74194C10.3871 4.58065 10.129 4.58065 10 4.74194L8 6.74194L5.96774 4.74194C5.83871 4.58065 5.58065 4.58065 5.41935 4.74194L4.70968 5.45161C4.54839 5.6129 4.54839 5.87097 4.70968 6L6.70968 8L4.70968 10.0323C4.54839 10.1613 4.54839 10.4194 4.70968 10.5806L5.41935 11.2903C5.58065 11.4516 5.83871 11.4516 5.96774 11.2903L8 9.29032L10 11.2903C10.129 11.4516 10.3871 11.4516 10.5484 11.2903L11.2581 10.5806C11.4194 10.4194 11.4194 10.1613 11.2581 10.0323L9.25806 8L11.2581 6Z"
  }));
};

TimesCircleIcon.defaultProps = {
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var getIconBy = function getIconBy(type) {
  switch (type) {
    case 'success':
      return /*#__PURE__*/_react.default.createElement(CheckCircleIcon, null);

    case 'error':
      return /*#__PURE__*/_react.default.createElement(TimesCircleIcon, null);

    default:
      return /*#__PURE__*/_react.default.createElement(InfoIcon, null);
  }
};

var showToast = function showToast(_ref) {
  var _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'info' : _ref$type,
      message = _ref.message;
  (0, _reactToastify.toast)(message, {
    type: type,
    theme: 'colored',
    icon: /*#__PURE__*/_react.default.createElement(_styles.Icon, null, getIconBy(type))
  });
};

exports.showToast = showToast;

var ToastAnimated = function ToastAnimated(_ref2) {
  var position = _ref2.position,
      autoClose = _ref2.autoClose,
      newestOnTop = _ref2.newestOnTop;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_styles.GlobalToastStyle, null), /*#__PURE__*/_react.default.createElement(_styles.Toast, {
    position: position,
    autoClose: autoClose,
    newestOnTop: newestOnTop
  }));
};

ToastAnimated.defaultProps = {
  position: 'top-right',
  autoClose: 5000,
  newestOnTop: false
};
var _default = ToastAnimated;
exports.default = _default;